import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Callout, FlexBox, ICalloutProps, Icon, Typography } from '@agilepoint/wat-react-ux';

interface ICustomTooltipProps extends ICalloutProps {
    tooltipContent?: string;
    tooltipContentRenderer?: () => React.ReactNode;
    calloutHeight?: string;
    calloutWidth?: string;
}

const StyledIcon = styled(Icon)`
  fill: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant3};  
`;

const StyledCallout = styled(Callout) <Pick<ICustomTooltipProps, 'calloutHeight' | 'calloutWidth'>>`
    width: ${({ calloutWidth }) => calloutWidth ?? '300px'};
    height: ${({ calloutHeight }) => calloutHeight};
    padding: 10px 15px;
    background-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant3};
    color: ${({ theme: { semantics } }) => semantics.palette.white};
    .ap-callout-content, span {
        background-color: inherit;
        border: none;
    }
`;

export const CustomTooltip = React.memo((props: ICustomTooltipProps) => {
    const { tooltipContentRenderer, calloutHeight, calloutWidth, tooltipContent, ...rest } = props;
    const [showTooltip, setShowToolTip] = React.useState(false);
    const helpIconRef = React.createRef<HTMLDivElement>();

    const onMouseMoveAction = React.useCallback((ev) => {
        ev.stopPropagation();
        setShowToolTip((prevValue) => !prevValue);
    }, []);

    const renderTooltipContent = useCallback(() => (
        <>
            {
                tooltipContentRenderer
                    ? tooltipContentRenderer()
                    : <Typography.Small title={tooltipContent}>{tooltipContent}</Typography.Small>
            }
        </>
    ), [tooltipContent, tooltipContentRenderer]);

    return (
        <>
            <FlexBox ref={helpIconRef} className="ap-helpicon-wrapper" onMouseOver={onMouseMoveAction} onMouseOut={onMouseMoveAction} width='16px' height='16px'>
                <StyledIcon iconName='ap-help2.outline' iconSize='16' />
            </FlexBox>
            {
                showTooltip
                    ?
                    <StyledCallout
                        targetRef={helpIconRef}
                        calloutHeight={calloutHeight}
                        calloutWidth={calloutWidth}
                        hidden={false} isBeakVisible beakWidth={10} {...rest}>
                        {renderTooltipContent()}
                    </StyledCallout>
                    : <></>
            }
        </>
    );
});
